import Icon from '@mdi/react';
import { mdiChevronRight, mdiMenu } from '@mdi/js';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import HomeHeader from '../assets/home-header.svg';
import SearchIcon from '../assets/search-normal.svg';
import WaitListLink from './WaitListLink';
import ContactUsLink from './ContactUsLink';

function Header({ toggleMobileMenu }) {
  return (
    <header className="text-xl">
      <nav className="flex items-center justify-between p-3">
        <div className="d-flex__col logo-link-container w-2/5 md:w-1/5 lg:w-1/4 lg:max-w-52">
          <Link to="/">
            <img src={HomeHeader} alt="Home" className="w-full" />
          </Link>
        </div>
        <div className="flex justify-center items-center sm:hidden">
          <button
            type="button"
            className="bg-gold border-2 border-gold rounded-md py-1 px-1.5 icon-container icon-container-medium"
            onClick={toggleMobileMenu}
          >
            <Icon path={mdiMenu} className="text-white" />
          </button>
        </div>
        <form
          action="#"
          className="header-form hidden xl:flex p-2 bg-white-variant gap-3 items-center rounded-lg"
        >
          <div className="flex">
            <button
              type="submit"
              className="icon-container icon-container-medium"
            >
              <img src={SearchIcon} alt="Search Icon" />
            </button>
          </div>
          <div className="flex flex-1">
            <input
              type="text"
              name="search"
              id="search"
              placeholder="search"
              className="text-xs focus:text-lg transition-all duration-300 ease-in-out focus:outline-none bg-white-variant focus:border-0 focus:border-b focus:border-opaque-gold"
            />
          </div>
        </form>
        <ul className="nav-list hidden md:flex md:items-center md:gap-4">
          <li>
            <HashLink to="/#about" smooth>
              <span className="py-2  px-3 xl:py-3 xl:px-5 text-black-opaque-4  font-semibold">
                About
              </span>
            </HashLink>
          </li>
          <li>
            <HashLink to="/#faqs" smooth>
              <span className="py-2  px-3 xl:py-3 xl:px-5 text-black-opaque-4  font-semibold">
                FAQs
              </span>
            </HashLink>
          </li>
          <li>
            <ContactUsLink
              childEl={
                <span className="py-2  px-3 xl:py-3 xl:px-5 text-black-opaque-4  font-semibold">
                  Contact Us
                </span>
              }
            />
          </li>
          <li>
            <WaitListLink
              childEl={
                <button
                  type="button"
                  className="py-2 px-3 xl:py-3 xl:px-5 flex items-center gap-1 text-white bg-gold font-bold rounded-xl"
                >
                  <span>Join Wait List</span>
                  <span className="icon-container icon-container-medium">
                    <Icon path={mdiChevronRight} size={2} />
                  </span>
                </button>
              }
            />
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
